<template>
  <v-card class="ui-module-card ui-module-fade-in-up loc-shell" color="primary">
    <v-card-text>
      <v-tabs class="mb-3" v-model="selectedTab" color="secondary">
        <v-tab class="font-weight-bold">LOC</v-tab>
        <v-tab class="font-weight-bold">Remesas</v-tab>
      </v-tabs>
      <v-tabs-items v-model="selectedTab" class="transparent">
        <v-tab-item key="1" eager>
          <LicenciaOficialColectivaTabContent />
        </v-tab-item>
        <v-tab-item key="2" eager>
          <RemesasTabContent />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import LicenciaOficialColectivaTabContent from '@/components/armeria/licencia-oficial-colectiva/tab-content/LicenciaOficialColectivaTabContent.vue'
import RemesasTabContent from '@/components/armeria/licencia-oficial-colectiva/tab-content/RemesasTabContent.vue'

export default {
  components: {
    LicenciaOficialColectivaTabContent,
    RemesasTabContent,
  },
  data() {
    return {
      selectedTab: 0,
    }
  },
  async created() {
    await this.fetchLocs()
    await this.fetchRemesas()
  },
  methods: {
    ...mapActions('licenciaOficialColectiva', ['fetchLocs']),
    ...mapActions('remesas', ['fetchRemesas']),
  },
}
</script>

<style scoped>
.loc-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}
</style>
